import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "other-car"
}
const _hoisted_2 = { class: "info" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "d-inline-block" }, "UWAGA - przeglądasz dane dla:  ", -1)
const _hoisted_4 = { class: "bold d-inline-block" }
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.shouldShowError())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.car?.name), 1),
          (_ctx.getSelectedCar?.typeId)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: {
            name: 'tec-estimate-list',
            params: { typeId: _ctx.getSelectedCar.typeId },
          }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Zobacz dane dla twojego wybranego auta.")
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}